import React from 'react';
export function StatsSection() {
  const stats = [{
    number: '2.323',
    label: 'Hôtels classés'
  }, {
    number: '1,21 M',
    label: 'Fréquentation touristique'
  }, {
    number: '4,08 jours',
    label: 'Durée moyenne du séjour'
  }];
  return <section className="bg-white py-[120px]" data-id="element-223">
      <div className="container mx-auto px-4 md:px-8" data-id="element-224">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center" data-id="element-225">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center justify-center" data-id="element-226">
              <span className="text-[56px] md:text-[72px] font-bold text-arih-dark leading-none mb-4" data-id="element-227">
                {stat.number}
              </span>
              <span className="text-[18px] text-arih-gray font-medium" data-id="element-228">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}